<div class="container" *ngIf="finishedLoading">
  <div class="row">
    <div class="col-sm-12">
      <h4>Start</h4>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4">
      <div class="row">
        <div class="col-sm-12">
          <div class="header" [routerLink]="['../dashboard']">
            Kunden
          </div>
        </div>
      </div>
      <div class="row marginBottom2Rem"  *ngIf="showPendingCustomersCount">
        <div class="col-sm-12">
          <mat-card class="example-card">
            <mat-card-subtitle>Kunden</mat-card-subtitle>
            <mat-card-title>
              <span color="primary">
                {{ pendingCustomersCount}}
              </span>
              Kunden Warten auf Freigabe
            </mat-card-title>
            <mat-card-content>
              <h2></h2>
              <p>
                Diese Kunden müssen noch von einem Sachbearbeiter freigegeben werden, um das Portal nutzen zu können.
              </p>
            </mat-card-content>
            <mat-card-actions align="start">
              <button mat-button color="primary" (click)="moveToDashBoardPageWithFilter('PENDING')">Zur Liste</button>
            </mat-card-actions>
            <mat-card-footer>
              <mat-progress-bar class="green-progress" mode="determinate" *ngIf="pendingCustomersCount <= 10">
              </mat-progress-bar>
              <mat-progress-bar class="yellow-progress" mode="determinate"
                *ngIf="pendingCustomersCount > 10 && pendingCustomersCount<30"></mat-progress-bar>
              <mat-progress-bar class="red-progress" mode="determinate" *ngIf="pendingCustomersCount >= 30">
              </mat-progress-bar>
            </mat-card-footer>
          </mat-card>
        </div>
      </div>
      <div class="row marginBottom2Rem" *ngIf="this.showNonEligibleUsersCount">
        <div class="col-sm-12" >
          <mat-card class="example-card">
            <mat-card-subtitle>Kunden</mat-card-subtitle>
            <mat-card-title>{{
              nonEligibleUsersCount}}
              Fehlende Portalberechtigung</mat-card-title>
            <mat-card-content>
              <p>
                Diese Kunden haben aktuell keine gültigen Verträge und können aus diesem Grund das Portal
                nicht nutzen.
              </p>
            </mat-card-content>
            <mat-card-actions align="start">
              <button mat-button color="primary" (click)="moveToDashBoardPageWithFilter('hasNoValidELV')">Zur
                Liste</button>
            </mat-card-actions>
            <mat-card-footer>
              <mat-progress-bar class="green-progress" mode="determinate" *ngIf="nonEligibleUsersCount <= 10">
              </mat-progress-bar>
              <mat-progress-bar class="yellow-progress" mode="determinate"
                *ngIf="nonEligibleUsersCount > 10 && nonEligibleUsersCount<30"></mat-progress-bar>
              <mat-progress-bar class="red-progress" mode="determinate" *ngIf="nonEligibleUsersCount >= 30">
              </mat-progress-bar>
            </mat-card-footer>
          </mat-card>
        </div>
      </div>
      <div class="row marginBottom2Rem">
        <div class="col-sm-12">
          <mat-card class="example-card">
            <mat-card-subtitle>Kunden</mat-card-subtitle>
            <mat-card-title>
              {{waitingForDeactivationCount}} Warten auf Deaktivierung</mat-card-title>
            <mat-card-content>
              <p>
                Diese Kunden müssen noch von einem Sachbearbeiter deaktiviert werden, da ihre Verträge ausgelaufen sind.
              </p>
            </mat-card-content>
            <mat-card-actions align="start">
              <button mat-button color="primary" (click)="moveToDashBoardPageWithFilter('DISABLE_REQUEST')">Zur
                Liste</button>
            </mat-card-actions>
            <mat-card-footer>
              <mat-progress-bar class="green-progress" mode="determinate" *ngIf="waitingForDeactivationCount <= 10">
              </mat-progress-bar>
              <mat-progress-bar class="yellow-progress" mode="determinate"
                *ngIf="waitingForDeactivationCount > 10 && waitingForDeactivationCount<30"></mat-progress-bar>
              <mat-progress-bar class="red-progress" mode="determinate" *ngIf="waitingForDeactivationCount >= 30">
              </mat-progress-bar>
            </mat-card-footer>
          </mat-card>
        </div>
      </div>

      <div class="row marginBottom2Rem">
        <div class="col-sm-12">
          <mat-card class="example-card">
            <mat-card-subtitle>Haushalte </mat-card-subtitle>
            <mat-card-title> {{householdCount}} Haushalte mit >= 6 Erwachsene</mat-card-title>
            <mat-card-content>
              <p>

              </p>
            </mat-card-content>
            <mat-card-actions align="end">
              <button mat-button color="primary" (click)="moveToDashBoardPageWithFilter('household')">Zur Liste</button>
            </mat-card-actions>
            <mat-card-footer>
              <mat-progress-bar class="green-progress" mode="determinate" *ngIf="householdCount <= 10">
              </mat-progress-bar>
              <mat-progress-bar class="yellow-progress" mode="determinate"
                *ngIf="householdCount > 10 && householdCount<30"></mat-progress-bar>
              <mat-progress-bar class="red-progress" mode="determinate" *ngIf="householdCount >= 30">
              </mat-progress-bar>
            </mat-card-footer>

          </mat-card>
        </div>
      </div>
    </div>

    <div class="col-sm-4" *ngIf="hasCardProductionView">
      <div class="row">
        <div class="col-sm-12">
          <div class="header" [routerLink]="['../card']">
            Karte
          </div>
        </div>
      </div>
      <div class="row marginBottom2Rem">
        <div class="col-sm-12">
          <mat-card class="example-card">
            <mat-card-subtitle>Karte</mat-card-subtitle>
            <mat-card-title>{{ firstCardsCount}} Erstmalig drucken
            </mat-card-title>
            <mat-card-content>
              <p>
                Bei diesen Kunden muss die Kundenkarte erstmalig ausgestellt werden.
              </p>
            </mat-card-content>
            <mat-card-actions align="start">
              <button mat-button color="primary" (click)="moveToDashBoardPageWithFilter('hasNoCard')">Zur Liste</button>
            </mat-card-actions>
            <mat-card-footer>
              <mat-progress-bar class="green-progress" mode="determinate" *ngIf="firstCardsCount <= 10">
              </mat-progress-bar>
              <mat-progress-bar class="yellow-progress" mode="determinate"
                *ngIf="firstCardsCount > 10 && firstCardsCount<30"></mat-progress-bar>
              <mat-progress-bar class="red-progress" mode="determinate" *ngIf="firstCardsCount >= 30">
              </mat-progress-bar>
            </mat-card-footer>
          </mat-card>
        </div>
      </div>
      <div class="row marginBottom2Rem">
        <div class="col-sm-12">
          <mat-card class="example-card">
            <mat-card-subtitle>Karte</mat-card-subtitle>
            <mat-card-title>{{newCardCount}} Neu produzieren
            </mat-card-title>
            <mat-card-content>
              <p>
                Den Kunden wurde bereits eine Kundenkarte ausgehändigt, diese wurde aber gesperrt (weil beschädigt oder
                verloren).
              </p>
            </mat-card-content>
            <mat-card-actions align="start">
              <button mat-button color="primary" (click)="moveToDashBoardPageWithFilter('newCard')">Zur Liste</button>
            </mat-card-actions>
            <mat-card-footer>
              <mat-progress-bar class="green-progress" mode="determinate" *ngIf="newCardCount <= 10"></mat-progress-bar>
              <mat-progress-bar class="yellow-progress" mode="determinate" *ngIf="newCardCount > 10 && newCardCount<30">
              </mat-progress-bar>
              <mat-progress-bar class="red-progress" mode="determinate" *ngIf="newCardCount >= 30"></mat-progress-bar>
            </mat-card-footer>
          </mat-card>
        </div>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="row">
        <div class="col-sm-12">
          <div class="header" [routerLink]="['../dashboard']" [queryParams]="{  erpState: 'PARTIAL_MATCH' }">
            ERP Synchronisation
          </div>
        </div>
      </div>
      <div class="row marginBottom2Rem">
        <div class="col-sm-12">
          <mat-card class="example-card">
            <mat-card-subtitle>Manuelle Prüfung </mat-card-subtitle>
            <mat-card-title>{{
              partialMatchCount}} Kunden</mat-card-title>
            <mat-card-content>
              <p>
                Diese Kunden müssen noch freigegeben werden.
              </p>
            </mat-card-content>
            <mat-card-actions align="start">
              <button mat-button color="primary" (click)="moveToDashBoardPageWithFilter('partialMatchCount')">Zur
                Liste</button>
            </mat-card-actions>
            <mat-card-footer>
              <mat-progress-bar class="green-progress" mode="determinate" *ngIf="partialMatchCount <= 10">
              </mat-progress-bar>
              <mat-progress-bar class="yellow-progress" mode="determinate"
                *ngIf="partialMatchCount > 10 && partialMatchCount<30"></mat-progress-bar>
              <mat-progress-bar class="red-progress" mode="determinate" *ngIf="partialMatchCount >= 30">
              </mat-progress-bar>
            </mat-card-footer>
          </mat-card>
        </div>

      </div>



    </div>

    <!-- </div>

  <div class="row"> -->
    <div class="col-sm-4">
      <div class="row">
        <div class="col-sm-12">
          <div class="header" [routerLink]="['../report']">
            Reporting
          </div>
        </div>
      </div>

      <div class="row marginBottom2Rem">
        <div class="col-sm-12">
          <mat-card class="example-card">
            <mat-card-subtitle>Reporting
            </mat-card-subtitle>
            <mat-card-title>
              Aktionsreporting
            </mat-card-title>
            <mat-card-content>
              <h2></h2>
              <p>
                Reporting zur Performance der Aktionen
              </p>
            </mat-card-content>
            <mat-card-actions align="start">
              <button mat-button color="primary" [routerLink]="['/caseworker/report']">Zum Reporting</button>
            </mat-card-actions>
            <mat-card-footer>
              <mat-progress-bar class="green-progress" mode="determinate"></mat-progress-bar>
            </mat-card-footer>
          </mat-card>
        </div>
      </div>
    </div>


    <div class="col-sm-4" *ngIf="this.config?.showTicketView">
      <div class="row">
        <div class="col-sm-12">
          <div class="header" [routerLink]="['../ticket']">
            Sonstige Vorgänge
          </div>
        </div>
      </div>
      <div class="row marginBottom2Rem">
        <div class="col-sm-12">
          <mat-card class="example-card">
            <mat-card-subtitle>Online-Formulare
            </mat-card-subtitle>
            <mat-card-title>
              <span color="primary"> {{ formCount}} </span> Dokumente
            </mat-card-title>
            <mat-card-content>
              <h2></h2>
              <p> Formulare finden </p>
            </mat-card-content>
            <mat-card-actions align="start">
              <button mat-button color="primary" (click)="moveToTicketPageWithFilter('NEW')">Zur Liste</button>
            </mat-card-actions>
            <mat-card-footer>
              <mat-progress-bar class="green-progress" mode="determinate" *ngIf="formCount <= 10"></mat-progress-bar>
              <mat-progress-bar class="yellow-progress" mode="determinate" *ngIf="formCount > 10 && formCount<30">
              </mat-progress-bar>
              <mat-progress-bar class="red-progress" mode="determinate" *ngIf="formCount >= 30"></mat-progress-bar>
            </mat-card-footer>
          </mat-card>
        </div>
      </div>
    </div>


    <div class="col-sm-4">
      <div class="row marginBottom2Rem">
        <!-- <div class="col-sm-12">
          <mat-card class="example-card">
            <mat-card-subtitle>Reporting
            </mat-card-subtitle>
            <mat-card-title>
              Nutzerreporting
            </mat-card-title>
            <mat-card-content>
              <h2></h2>
              <p> 
                Reporting zu Kundendaten
               </p>
            </mat-card-content>
            <mat-card-actions align="start">
              <button mat-button color="primary" [routerLink]="['/caseworker/userreport']">Zum Reporting</button>
            </mat-card-actions>
            <mat-card-footer>
              <mat-progress-bar class="green-progress" mode="determinate"></mat-progress-bar>
            </mat-card-footer>
          </mat-card>
        </div>       -->
      </div>
    </div>
  </div>

  <button class="fabAddBtnBottomRight" mat-fab color="primary" (click)="reloadPage()" [matTooltipPosition]="'above'"
    matTooltip="Daten aktualisieren">
    <mat-icon>refresh</mat-icon>
  </button>

  <button class="fabListBtnBottomRight" mat-fab color="accent" [routerLink]="['../dashboard/overviewCustomer']" [disabled]="usesSSO">
    <mat-icon>add</mat-icon>
  </button>

</div>

<div class="container" *ngIf="!finishedLoading">
  <div class="row">
    <div class="col-sm-12 padding">
      <div class="loadingOverlay">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  </div>
</div>